export class PromuoviClasse {
    grado?: number;
    referente?: boolean;
    classePrecedenteId?: string;
    materie?: Array<string>;
    studenti?: Array<string>;
}